export default function Footer() {
  return (
    <div className="Footer">
      <footer className="mt-3">
        <small>
          The project was coded by Sobkovych Nataliya and is{" "}
          <a
            href="https://github.com/nsobkovych/weather-app-react"
            target="_blank"
            rel="noreferrer"
          >
            open-sourced on GitHub
          </a>{" "}
          and hosted{" "}
          <a
            href="https://voluble-mandazi-96742e.netlify.app/"
            target="_blank"
            rel="noreferrer"
          >
            on Netlify
          </a>
        </small>
      </footer>
    </div>
  );
}
